import { useMediaQuery } from '@mui/material';
import type { ProductListAPIResponse } from '@partful/shared-types';
import { ContentPadding } from 'src/components/ContentPane';
import { Footer } from 'src/components/Footer';
import { ProductLibraryBackground } from 'src/components/ProductLibraryBackground';
import ProductList from 'src/components/ProductList';
import { device } from 'src/constants/mediaQueries';
import { MainTemplate } from 'src/templates/MainTemplate';
import { DesktopProductCategoryHeader } from './Desktop/DesktopProductCategoryHeader';
import EmptyCategoryPage from './EmptyCategoryPage';
import { MobileProductCategoryHeader } from './Mobile/MobileProductCategoryHeader';

export type MessageType = 'error' | 'success';
export type DisplayMessageHandler = (title: string, message: string, messageType: MessageType) => void;

interface ProductCategoryPageProps {
  products: ProductListAPIResponse;
  decodedPathEnumeration: string;
}

/* istanbul ignore next - this needs fixing */
export function ProductCategoryPage({ products, decodedPathEnumeration }: Readonly<ProductCategoryPageProps>) {
  const isMobile = useMediaQuery(device.mobileOrTablet);
  const filteredProducts = products.filter(({ productCategories }) =>
    productCategories?.includes(decodedPathEnumeration)
  );

  return (
    <MainTemplate>
      <ProductLibraryBackground>
        <ContentPadding>
          {isMobile ? (
            /* istanbul ignore next */
            <MobileProductCategoryHeader />
          ) : (
            <DesktopProductCategoryHeader decodedPathEnumeration={decodedPathEnumeration} />
          )}
          {!filteredProducts.length ? <EmptyCategoryPage /> : <ProductList products={filteredProducts} />}
        </ContentPadding>
      </ProductLibraryBackground>
      <Footer />
    </MainTemplate>
  );
}
